import Icon from '../components/Icon.vue'

Icon.register({"user-shield":{"width":640,"height":512,"paths":[{"d":"M622.3 271.1L507.1 226.1C503 224.5 494.5 222.4 484.9 226.1L369.7 271.1C359 275.3 352 285.1 352 296 352 407.6 420.7 484.8 484.9 509.9 494.5 513.6 502.9 511.5 507.1 509.9 558.4 489.9 640 420.5 640 296 640 285.1 633 275.3 622.3 271.1zM496 462.4V273.3L591.5 310.6C585.9 397.7 530.6 446 496 462.4zM224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM320 296C320 293.5 320.8 291.2 321.1 288.8 318.6 288.7 316.2 288 313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H400C406.8 512 413.3 510.5 419.2 508 365.2 465.1 320 391.3 320 296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-shield.js
// module id = sAQP
// module chunks = 0